import { NavigationHeaderModel } from "@models/site";
import { Variants, motion } from "framer-motion";
import React, { useState } from "react";
import MobileNavItem from "./NavItem";
import Button from "@components/common/Button";
import Link from "@components/common/Link";

export interface MenuBarPropsModel {
  navigation: NavigationHeaderModel;
  isOpen: boolean;
  setShowMenu: React.Dispatch<React.SetStateAction<boolean>>;
}

const menuBarVariant: Variants = {
  close: {
    width: 0,
    height: 0,
    transition: {
      delay: 0.7,
      type: "spring",
      stiffness: 400,
      damping: 40,
    },
  },
  open: {
    width: "100vw",
    height: "101dvh",
  },
};

const ulVariants = {
  close: {
    transition: {
      staggerChildren: 0.1,
      staggerDirection: -1,
    },
  },
  open: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.5,
    },
  },
};
const listVariant: Variants = {
  close: {
    opacity: 0,
  },
  open: {
    opacity: 1,
  },
};

const MenuBar: React.FunctionComponent<MenuBarPropsModel> = ({
  navigation,
  isOpen,
  setShowMenu,
}) => {
  const { items } = navigation ?? {};
  const { data: mainHeaderDataObjects } = items ?? {};
  const [selectedSubMenu, setSelectedSubMenu] = useState("");

  return (
    <motion.div
      className="absolute w-screen top-[64px] bg-white z-[9999] right-0 overflow-y-auto shadow-xl pb-8"
      variants={menuBarVariant}
      initial="close"
      animate={isOpen ? "open" : "close"}
    >
      <motion.ul
        variants={ulVariants}
        className="px-4 bg-white overflow-y-auto"
      >
        {mainHeaderDataObjects?.map((oneMainHeaderDataObject) => {
          const { attributes } = oneMainHeaderDataObject ?? {};
          return (
            <MobileNavItem
              navAttributes={attributes}
              key={oneMainHeaderDataObject.id}
              selectedSubMenu={selectedSubMenu}
              setSelectedSubMenu={setSelectedSubMenu}
              setShowMenu={setShowMenu}
              isMenuOpen={isOpen}
            />
          );
        })}
        <motion.li className="flex py-14 gap-5" variants={listVariant}>
          <Button style={{ height: "43px", marginLeft: "16px" }}>
            <Link
              href="/demo"
              linkText="REQUEST DEMO"
              wrapperClassName="hover:no-underline"
              style={{
                color: "inherit",
                fontSize: "12px",
                textDecoration: "none",
              }}
            />
          </Button>
        </motion.li>
      </motion.ul>
    </motion.div>
  );
};
export default MenuBar;
